export * as Record from './Record';

export type Type<T> = {
	[key: string]: T;
};

export function create<T>(): Type<T> {
	return {} as Type<T>;
}

export function removeNullValues<T>(input: Type<T>): Type<T> {
	const output: Type<T> = {};
	for (const [key, value] of Object.entries(input)) {
		if (value === null) continue;
		output[key] = value;
	}
	return output;
}
